<div class="search-container mt-2 mb-1 flex">
    <div class="w-full md:w-1/3">
        <mat-form-field appearance="fill" class="field-bg-gray w-full">
            <mat-label
                class="inline-flex items-center gap-1 vertical-align-top"
            >
                <mat-icon
                    [style.color]="color_primario || ''"
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:magnifying-glass'"
                ></mat-icon>
                Buscar...</mat-label
            >
            <input
                matInput
                type="text"
                data-search-input="true"
                class="search-integrated-input"
                [(ngModel)]="filter"
                (input)="applyFilter($event)"
                placeholder="Buscar..."
            />
            <button
                mat-icon-button
                *ngIf="filter"
                matSuffix
                (click)="resetFilter()"
                class="mr-2"
            >
                <mat-icon class="text-gray-700">close</mat-icon>
            </button>
            <mat-icon *ngIf="!filter" matSuffix>search</mat-icon>
        </mat-form-field>
    </div>
</div>
